/**
 * Emit hosts for the `navigation` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function navigationGetStartedFAQ() {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.NavigationGetStartedFAQ,
    },
  });
}

export function navigationHelp() {
  trackLegacyEvent({
    name: SegmentObjectName.Navigation,
    props: {
      action: SegmentActionName.NavigationHelp,
    },
  });
}

// Navigation
export function navigationRoadmap() {
  trackLegacyEvent({
    name: SegmentObjectName.Navigation,
    props: {
      action: SegmentActionName.NavigationRoadmap,
    },
  });
}
